import { Route, Routes } from 'react-router-dom'
import ScrollToTop from '../Components/ScrollToTop/ScrollToTop'
import Home from '../Screens/Home/Home'
import Gallery from '../Screens/Gallery/Gallery'
import TermsAndConditions from '../Screens/TermsAndConditions/TermsAndConditions'
import PrivacyPolicy from '../Screens/PrivacyPolicy/PrivacyPolicy'
import Accessibility from '../Screens/Accessibility/Accessibility'
import WhereWeBuild from '../Screens/WhereWeBuild/WhereWeBuild'
import WhyChooseUs from '../Screens/WhyChooseUs/WhyChooseUs'
import Layout from '../Layout/Layout'
import ContactUs from '../Screens/ContactUs/ContactUs'
import About from '../Screens/About/About'

function AppRoute() {
    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Layout><Home /></Layout>} />
                <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
                <Route path="/terms-and-conditions" element={<Layout><TermsAndConditions /></Layout>} />
                <Route path="/privacy-policy" element={<Layout><PrivacyPolicy /></Layout>} />
                <Route path="/accessibility" element={<Layout><Accessibility /></Layout>} />
                <Route path="/where-we-build" element={<Layout><WhereWeBuild /></Layout>} />
                <Route path="/why-choose-us" element={<Layout><WhyChooseUs /></Layout>} />
                <Route path="/contact" element={<Layout><ContactUs /></Layout>} />
                <Route path="/about" element={<Layout><About /></Layout>} />
            </Routes>
        </>
    )
}

export default AppRoute
